export enum ResidentLogs {
    OpenApp = "APP_OPEN",
    OpenFamily = "FAMILY_BUTTON_PRESSED",
    OpenNews = "NEWS_OPEN",
    OpenNotifications = "NOTIFICATIONS_OPEN",
    Calls = "MYDAY_SCHEDULED_CALL_JOINED",
    FamilyChatUsage = "FAMILY_CHAT_OPENED",
    ResidentChatUsage = "RESIDENT_CHAT_OPENED",
    MediaUsage = "MEDIA_OPENED",
    MediaAppOpenned = "MEDIA_APP_OPENED",
    OpennedService = "PREMIUM_SERVICE_VIEWED",
    ViewService = "PREMIUM_SERVICES_OPEN",
    CalendarEventsOpen = "MYDAY_EVENT_OPEN",
    PremiumEventsOpen = "MYDAY_PREMIUM_EVENT_OPEN",
    LifestyleEventsOpen = "MYDAY_LIFESTYLE_EVENT_OPEN",
    ConciergeEventsOpen = "MYDAY_CONCIERGE_EVENT_OPEN",
    EventsOpen = "EVENTS_OPENED",
    EventsNotAttendingOpen = "EVENTS_NOT_ATTENDING_OPENED",
    EventsNotAttending = "VIEW_EVENT_NOT_ATTENDING_OPENED",
    
    ChatUsage = "CHAT_OPENED",
}